import { calculateDifference } from '@app/utils/filter/terms/calculate-difference';
import { Value } from '@app/utils/filter/terms/value';

export type LessThanOrEquals = {
  arguments: [Value];
  key: string;
  operator: 'lte';
};

export const lessThanOrEquals = function (value: any, upperBound: Value): boolean {
  return calculateDifference(value, upperBound) >= 0;
};
